const state = {
  loadingDialog: {
    isVisible: false,
    type: '',
    message: ''
  },
  customAlert: {
    isVisible: false,
    title: '타이틀',
    description: '설명',
    cancelBtnText: '닫기',
    confirmBtnText: '확인',
    confirmBtnHandler: () => {},
    cancelBtnHandler: () => {}
  }
};

const mutations = {
  setLoadingDialogStatus(state, { target, value }) {
    state.loadingDialog[target] = value;
  },
  setCustomAlertStatus(state, { target, value }) {
    state.customAlert[target] = value;
  },
  setBulkCustomAlertStatus(state, status) {
    state.customAlert = {
      ...status
    };
  }
};

const getters = {
  getLoadingDialogVisible() {
    return state.loadingDialog.isVisible;
  },
  getLoadingDialogMessage() {
    return state.loadingDialog.message;
  },
  getLoadingDialogType() {
    return state.loadingDialog.type;
  },
  getCustomAlertVisible() {
    return state.customAlert.isVisible;
  },
  getCustomAlertCancelBtnHandler() {
    return state.customAlert.cancelBtnHandler;
  },
  getCustomAlertConfirmBtnHandler() {
    return state.customAlert.confirmBtnHandler;
  },
  getCustomAlertCancelText() {
    return state.customAlert.cancelBtnText;
  },
  getCustomAlertConfirmText() {
    return state.customAlert.confirmBtnText;
  },
  getCustomAlertTitle() {
    return state.customAlert.title;
  },
  getCustomAlertDescription() {
    return state.customAlert.description;
  }
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
};
